import { render, staticRenderFns } from "./TwoFactorSetup.vue?vue&type=template&id=d432d084&scoped=true"
import script from "./TwoFactorSetup.vue?vue&type=script&lang=js"
export * from "./TwoFactorSetup.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorSetup.vue?vue&type=style&index=0&id=d432d084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d432d084",
  null
  
)

export default component.exports